/**!
 * Created by Leonardo Cheslacki on 28/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import LayerController from './LayerController';

import {HelpersIcon} from './../helpers';

import pageConfig from './../../../../config/page.config';

import WithType from './../WithType';

class LayerDifferential extends LayerController {
    /**
     *
     * @param props
     * @param main
     * @returns {LayerDifferential}
     */
    constructor(props, main) {
        super(props);

        // if (LayerDifferential._this instanceof LayerDifferential) {
        //     return LayerDifferential._this;
        // }

        this.props = props;
        this.main = main;

        this.state = {
            effect: true
        }

        const {current_name} = this.props;

        this.$helpersIcon = HelpersIcon(this)({current_name: current_name});

        LayerDifferential._this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handleDifferentialSwitch: function (event) {
            const _this = LayerDifferential._this;

            _this.show(event);
        }
    };

    /**
     *
     * @param frame
     * @param visible
     */
    navigate = (frame, visible = false) => {
        const
            {effect} = this.state,
            {occ_differential, occ_icon_differential} = this.get();

        occ_icon_differential.occ_more.visible = !visible;
        occ_icon_differential.occ_less.visible = visible;

        if (visible) {
            occ_differential.gotoAndStop(frame);
            effect && this.effectFadeIn(occ_differential, `occ_frame_${this.occurrence()}`);
        } else {
            if (effect) {
                this.effectFadeOut(occ_differential, `occ_frame_${this.occurrence()}`, () => {
                    occ_differential.gotoAndStop(frame);
                });
            } else {
                occ_differential.gotoAndStop(frame);
            }
        }

        this.setState({...this.state, effect: true});
    };

    close = () => {
        this.navigate('empty');
    };

    /**
     *
     * @param event
     */
    show = (event = null) => {
        const
            {enabled} = this.props,
            {occ_icon_differential} = this.get();

        occ_icon_differential.occ_more.isVisible() || (this.isEmpty(event) && enabled) ? this.navigate(`frame${this.occurrence()}`, true) : this.close();
    };

    startDifferential = () => {
        const
            {enabled, color_icon} = this.props,
            {occ_differential, btn_differential, occ_icon_differential} = this.get();

        this.setHandleMouseDown(btn_differential, this.$functions.handleDifferentialSwitch);

        let btn_close = this.verifyField(occ_differential, 'btn_close');

        btn_close && this.setHandleMouseDown(btn_close, this.$functions.handleDifferentialSwitch);

        this.$helpersIcon.setColor(occ_icon_differential, color_icon, 'occ_more');
        this.$helpersIcon.setColor(occ_icon_differential, color_icon, 'occ_less');

        enabled ? this.show() : this.close();
    };

    mainDifferential = () => {
        this.startDifferential();
    };
}

/**
 *
 * @type {{}}
 */
LayerDifferential.propTypes = {
    current_name: PropTypes.string,
    color_icon: PropTypes.string,
    enabled: PropTypes.bool
};

/**
 *
 * @type {{}}
 */
LayerDifferential.defaultProps = {
    current_name: null,
    color_icon: pageConfig.button.color_icon,
    enabled: false
};

/**
 *
 * @type {{}}
 * @private
 */
LayerDifferential._this = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(LayerDifferential, {className: 'LayerDifferential'});
